const SAFE_PROTOCOLS = new Set(['http:', 'https:']);

export function sanitizeExternalUrl(value?: string): string | undefined {
  const trimmed = value?.trim();

  if (!trimmed) {
    return undefined;
  }

  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f-\u009f]/.test(trimmed)) {
    return undefined;
  }

  if (trimmed.startsWith('//')) {
    return undefined;
  }

  if (trimmed.startsWith('/')) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed);

    return SAFE_PROTOCOLS.has(url.protocol) ? url.toString() : undefined;
  } catch {
    return undefined;
  }
}

export interface ExternalLinkAttributes {
  href: string;
  target: '_blank';
  rel: 'noopener noreferrer';
}

export function externalLinkAttributes(
  value?: string,
): ExternalLinkAttributes | undefined {
  const href = sanitizeExternalUrl(value);

  return href
    ? { href, target: '_blank', rel: 'noopener noreferrer' }
    : undefined;
}

export type IconDisplayMode = 'Light' | 'Dark';

export function withIconVariant(
  assetPath: string,
  size: number,
  mode: IconDisplayMode,
): string {
  const lastSlash = assetPath.lastIndexOf('/');
  const lastDot = assetPath.lastIndexOf('.');

  if (lastDot <= lastSlash) {
    return `${assetPath}${size}${mode}`;
  }

  return `${assetPath.slice(0, lastDot)}${size}${mode}${assetPath.slice(
    lastDot,
  )}`;
}

export function normalizeAssetPath(path?: string): string | undefined {
  const trimmed = path?.trim();

  if (!trimmed || trimmed.startsWith('//')) {
    return undefined;
  }

  const [pathname] = trimmed.split(/[?#]/);
  const segments = pathname
    .split('/')
    .filter(segment => segment && segment !== '.' && segment !== '..');

  if (segments.length === 0) {
    return undefined;
  }

  return `/${segments.join('/')}`;
}
